import { Col } from 'react-bootstrap';

const PohCol = Col;

export default PohCol;
